<script>
    import { createSmartFilter } from '@/api/smartFilter.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_SMART_FILTER_ADD},
        },
        methods: {
            async create() {
                const data = this.$store.getters.SMART_FILTER_DATA_ADD;
                const response = await createSmartFilter(data);
                if (response != null) {
                    this.$store.commit('IMAGE_SMART_FILTERS_PUSH', response);
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_SMART_FILTER_ADD', false);
            }
        }
    }
</script>

<template>
    <button
        :disabled="isSave === false"
        @click="create"
        class="button_blue_100"
    >Create</button>
    <button
        @click="close"
        class="button_blue_100 close_button mr_10"
    >Close</button>
</template>